import React from 'react';
import ReactDOM from 'react-dom';
import App from 'App';
import * as serviceWorkerRegistration from 'serviceWorkerRegistration';
import reportWebVitals from 'reportWebVitals';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from 'core/store';
import { initDatadogRum } from 'core/services/datadog';

// Before render so RUM captures the initial page load and any early errors. No-op unless
// REACT_APP_DD_ENABLED is true, and always a no-op in UI-test/Jest builds (see datadog.ts).
initDatadogRum();

require('default-passive-events');

ReactDOM.render(
  <React.StrictMode>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
